/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { IUser } from '@pacifico/interfaces/auth-api.interface';
import {
	IDataCardAmountComponent,
	IDataCardSingleComponent,
	IDataTableActionComponent,
	IExtraHeaders
} from '@pacifico/interfaces/components.interface';
import { TokenService } from '@pacifico/services/api/token.service';
import { Row, Workbook } from 'exceljs';
import * as FileSaver from 'file-saver';
import { IImg, PdfMakeWrapper, Table, Txt, Ul } from 'pdfmake-wrapper';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as logo_pc from './logoBase64.js';

@Component({
	selector: 'app-buttons-reports',
	templateUrl: './buttons-reports.component.html',
	styleUrls: ['./buttons-reports.component.scss']
})
export class ButtonsReportsComponent implements OnInit {
	@Input() dataReport!: IDataTableActionComponent;
	@Input() listCardDetail: IDataCardAmountComponent[] = [];
	@Input() cardsingle: IDataCardSingleComponent[] = [];
	@Input() titleDetails = '';
	@Input() downloadName = '';
	@Input() extraheaders?: IExtraHeaders[] = [];
	userData!: IUser;
	userNameAndCode = '';
	title = '';

	constructor(private _tokenservice: TokenService, private _datePipe: DatePipe) {
		this.userData = this._tokenservice.getFullUser();
	}

	ngOnInit(): void {
		this.userNameAndCode = `NOMBRE SOCIO: ${this.userData.fullname}\t\tCÓDIGO SOCIO: ${this.userData.pCIP}`;
	}

	buildReport(tipe: string): void {
		if (this.dataReport.title !== undefined) {
			this.title = this.dataReport.title.toUpperCase();
		} else {
			this.title = this.titleDetails.toUpperCase();
		}
		switch (tipe) {
			case 'print': {
				let isdetail = true;
				if (this.dataReport.title) {
					isdetail = false;
				}
				this.printReportPDF(isdetail, false);
				break;
			}
			case 'downloadPDF': {
				let detailpdf = true;
				if (this.dataReport.title) {
					detailpdf = false;
				}
				this.printReportPDF(detailpdf, true);
				break;
			}
			case 'downloadXLS': {
				let detail = true;
				if (this.dataReport.title) {
					detail = false;
				}
				this.downloadReportXSL(detail);
				break;
			}
			default:
				break;
		}
	}

	/**
	 * este método permite descargar la tabla en formato excel con el logo unicamente en formato base64
	 * usa la libreria exceljs y file-saver
	 */
	downloadReportXSL(detail: boolean): void {
		const rowUserData = `NOMBRE SOCIO: ${this.userData.fullname}`;
		const codeUser = `CÓDIGO SOCIO: ${this.userData.pCIP}`;
		const header = this.extractHeaders(this.dataReport.headers);
		// create workbook
		const workbook = new Workbook();
		const worksheet = workbook.addWorksheet('Reporte');
		worksheet.properties.defaultColWidth = 15;
		const logo = workbook.addImage({
			base64: logo_pc.logoBase64,
			extension: 'png'
		});
		worksheet.mergeCells('A1:C4');
		worksheet.addImage(logo, 'A1:C4');

		if (!this.extraheaders || (this.extraheaders && this.extraheaders.length === 0)) {
			const dataUser: Row = worksheet.addRow([rowUserData, '', '', '', codeUser]);
			dataUser.font = { name: 'Arial', family: 4, size: 11 };
		} else {
			worksheet.addRow([]);
			this.extraheaders.forEach((extraHeader) => {
				const extra: Row = worksheet.addRow([extraHeader.text + ':', extraHeader.value]);
				extra.eachCell((cell, number) => {
					cell.font = {
						name: 'Arial',
						family: 4,
						size: 9,
						bold: true,
						color: { argb: number === 1 ? '004687CC' : '69829BCC' }
					};
					cell.alignment = { horizontal: 'left', shrinkToFit: false };
				});
			});
		}

		if (detail) {
			worksheet.addRow([]);
			worksheet.addRow(this.listCardDetail.map((item) => item.subTitle));
			worksheet.addRow(this.listCardDetail.map((item) => item.title));
			if (this.cardsingle.length) {
				worksheet.addRow([]);
				worksheet.addRow(this.cardsingle.map((item) => item.subTitle));
				worksheet.addRow(this.cardsingle.map((item) => item.title));
			}
		}

		worksheet.mergeCells(5, 1, 5, 3);
		worksheet.addRow([]);

		if (this.dataReport.data.length) {
			worksheet.addRow([this.title]);
			const headerRow = worksheet.addRow(header);
			// Cell Style : Fill and Border
			headerRow.eachCell((cell, number) => {
				cell.fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: 'FF6699CC' },
					bgColor: { argb: '00000000' }
				};
				cell.alignment = { horizontal: 'left', shrinkToFit: false };
				cell.border = {
					top: { style: 'thin', color: { argb: 'FF6699CC' } },
					left: { style: 'thin', color: { argb: 'FF6699CC' } },
					bottom: { style: 'thin', color: { argb: 'FF6699CC' } },
					right: { style: 'thin', color: { argb: 'FF6699CC' } }
				};
			});
			headerRow.font = { color: { argb: 'FFF0F8FF' } };

			this.extractDataTable(this.dataReport.data, header.length).forEach((item) => {
				if (item !== undefined) {
					const row = worksheet.addRow(
						item.map((element) => element.toString().replace('PEN', 'SOLES').replace('USD', 'DÓLARES'))
					);
					row.eachCell((cell, number) => {
						cell.alignment = { horizontal: 'left', shrinkToFit: false };
						cell.border = {
							top: { style: 'thin', color: { argb: 'FF6699CC' } },
							left: { style: 'thin', color: { argb: 'FF6699CC' } },
							bottom: { style: 'thin', color: { argb: 'FF6699CC' } },
							right: { style: 'thin', color: { argb: 'FF6699CC' } }
						};
					});
				}
			});

			if (this.dataReport.subtotalSoles?.totals.length) {
				const columStart = this.dataReport.subtotalSoles.indexColumnStart + 1;
				const datatotales: string[] = [];
				datatotales[columStart] = 'SUBTOTAL SOLES';
				this.dataReport.subtotalSoles.totals.forEach((item) => datatotales.push(item));
				const row = worksheet.addRow(datatotales);
				row.eachCell((cell, number) => {
					cell.alignment = { horizontal: 'left', shrinkToFit: false };
					cell.border = {
						top: { style: 'thin', color: { argb: 'FF6699CC' } },
						left: { style: 'thin', color: { argb: 'FF6699CC' } },
						bottom: { style: 'thin', color: { argb: 'FF6699CC' } },
						right: { style: 'thin', color: { argb: 'FF6699CC' } }
					};
				});
			}

			if (this.dataReport.subtotalDolares?.totals.length) {
				const columStart = this.dataReport.subtotalDolares.indexColumnStart + 1;
				const datatotales: string[] = [];
				datatotales[columStart] = 'SUBTOTAL DÓLARES';
				this.dataReport.subtotalDolares.totals.forEach((item) => datatotales.push(item));
				const row = worksheet.addRow(datatotales);
				row.eachCell((cell, number) => {
					cell.alignment = { horizontal: 'left', shrinkToFit: false };
					cell.border = {
						top: { style: 'thin', color: { argb: 'FF6699CC' } },
						left: { style: 'thin', color: { argb: 'FF6699CC' } },
						bottom: { style: 'thin', color: { argb: 'FF6699CC' } },
						right: { style: 'thin', color: { argb: 'FF6699CC' } }
					};
				});
			}
		} else {
			worksheet.addRow(['LA CUENTA NO TIENE DETALLES']);
		}

		worksheet.addRow([]);
		const date = new Date();
		worksheet.addRow([`Fecha: ${this._datePipe.transform(date, 'shortDate')!}`]);
		worksheet.addRow([`Lugar: Lima Perú`]);
		worksheet.addRow([`Hora: ${this._datePipe.transform(date, 'h:mm:ss a')!}`]);
		worksheet.getColumn('C').width = 30;
		worksheet.getColumn('B').width = 20;
		worksheet.getColumn('A').width = 20;
		worksheet.getColumn('D').width = 20;
		worksheet.getColumn('E').width = 20;
		if (this.title.includes('DETALLE')) {
			worksheet.getColumn('D').width = 50;
			worksheet.getColumn('C').width = 20;
		}

		//saving worlbook
		void workbook.xlsx.writeBuffer().then((data) => {
			const blob: Blob = new Blob([data], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});
			FileSaver.saveAs(blob, this.downloadName ? this.downloadName : `ReportesDeCuentas.xlsx`);
		});
	}

	/**
	 * este metodo permite descargar o imprimir la data en pdf
	 * usa la libreria pdfmake-wrapper
	 */
	printReportPDF(isdetail: boolean, download: boolean): void {
		const date = new Date();
		PdfMakeWrapper.setFonts(pdfFonts);
		const pdf = new PdfMakeWrapper();
		pdf.pageMargins([20, 40, 20, 40]);
		pdf.pageSize('A4');
		pdf.pageOrientation('portrait');
		pdf.defaultStyle({ fontSize: 8 });

		const dateheader = new Txt(`${this._datePipe.transform(date, 'dd/MM/YYYY hh:mm a')!}`)
			.margin([20, 10, 0, 0])
			.fontSize(8).end;
		pdf.header(dateheader);

		// if (download) {
		const logo: IImg = { image: logo_pc.logoBase64, fit: [180, 180] };
		pdf.add(logo);
		// } else {
		// 	pdf.add(pdf.ln(5));
		// }

		if (!this.extraheaders || (this.extraheaders && this.extraheaders.length === 0)) {
			const datauser = new Txt(`${this.userNameAndCode.toLocaleUpperCase()}`).alignment('left').fontSize(9).end;
			pdf.add(datauser);
			pdf.add(pdf.ln(1));
		} else {
			const title = new Txt(`${this.titleDetails}`).color('#274972').alignment('center').fontSize(16).bold().end;
			pdf.add(title);
			pdf.add(pdf.ln(1));
		}

		if (isdetail) {
			const cardheader = new Table([
				...[this.listCardDetail.map((item) => `${item.subTitle}: `)],
				...[this.listCardDetail.map((item) => item.title)]
			])
				.layout('noBorders')
				.fontSize(9)
				.margin(0).end;
			pdf.add(cardheader);
			if (this.cardsingle) {
				pdf.add(pdf.ln(1));
				const cardsingle = new Table([
					...[this.cardsingle.map((item) => `${item.subTitle}: `)],
					...[this.cardsingle.map((item) => item.title)]
				])
					.layout('noBorders')
					.fontSize(9)
					.widths('auto')
					.margin(0).end;
				pdf.add(cardsingle);
				pdf.add(pdf.ln(1));
			}
		}

		if (this.extraheaders && this.extraheaders.length > 0) {
			const table: any[][] = [];
			this.extraheaders.forEach((extraHeader) => {
				table.push([
					new Txt(`${extraHeader.text}:`).color('#004687').bold().end,
					new Txt(extraHeader.value).color('#69829b').bold().end
				]);
			});

			pdf.add(new Table(table).widths(['20%', 'auto']).layout('noBorders').fontSize(9).end);
			pdf.add(pdf.ln(1));
		}

		if (this.dataReport.data.length) {
			const title = new Txt(this.title).alignment('left').fontSize(9).end;
			pdf.add(title);
			const h: string[] = this.extractHeaders(this.dataReport.headers);
			//se crea la tabla y se asignan los estilos
			const table = new Table([
				[...h].map((item: string) => new Txt(item).alignment('center').width('auto').end),
				...this.joinDataTableAndSubtotals(this.dataReport.data, h.length).map((item: any) =>
					item.map((it: string, i) => {
						const cell = new Txt(it.toString().replace('PEN', 'SOLES').replace('USD', 'DÓLARES'));
						if (this.dataReport.configColumn) {
							const config = this.dataReport.configColumn.filter((conf) => conf.indexColumn === i && !conf.hidden);

							if (config.length) {
								cell.alignment(config[0].textAlign!).width('auto');
							}
						}

						return cell.end;
					})
				)
			])
				.dontBreakRows(true)
				.keepWithHeaderRows(5)
				.headerRows(2)
				.layout({
					paddingLeft: (i?: number, node?: any, columnIndex?: any) => 2,
					paddingRight: (i?: number, node?: any, columnIndex?: any) => 2
				});

			pdf.add(table.end);
			pdf.add(pdf.ln(1));
			pdf.add(
				new Ul([
					`Fecha: ${this._datePipe.transform(date, 'shortDate')!}`,
					`Lugar: Lima Perú`,
					`Hora: ${this._datePipe.transform(date, 'h:mm:ss a')!}`
				])
					.alignment('left')
					.type('none').end
			);
		} else {
			const titleDefault = new Txt('LA CUENTA NO TIENE DETALLES').alignment('center').fontSize(9).end;
			pdf.add(titleDefault);
		}

		if (download) {
			pdf.create().download(this.downloadName ? this.downloadName : 'Cuentas.pdf');
		} else {
			pdf.create().print();
		}
	}

	/**
	 *
	 * @param dataTable
	 * @param head
	 * @returns
	 */
	extractDataTable(dataTable: any[], head: number): any[] {
		return dataTable.map((value) => {
			return Object.values(new Object(value))
				.filter((_item, index) => !this.hiddenColumn(index))
				.slice(0, head);
		});
	}

	/**
	 * extrae las cabeceras de las tablas en los componentes table-action y table-basic y las filtra si no son ''
	 * @param headers
	 * @returns el mismo arreglo de cabeceras sin las etiquetas "br" y sin vacíos
	 */
	extractHeaders(headers: string[]): string[] {
		return headers
			.map((item) => item.replace(/<br\/>/g, ' '))
			.filter((item, index) => item !== '' && !this.hiddenColumn(index));
	}

	joinDataTableAndSubtotals(dataTable: any[], head: number): any[] {
		const body = dataTable.map((value) => {
			return Object.values(new Object(value))
				.filter((_item, index) => !this.hiddenColumn(index))
				.slice(0, head);
		});
		if (this.dataReport.subtotalSoles?.totals.length) {
			const totals: string[] = [];
			const init = this.dataReport.subtotalSoles.indexColumnStart;
			this.extractHeaders(this.dataReport.headers).forEach((it) => totals.push(''));
			totals[init] = 'SUB TOTAL SOLES';
			this.dataReport.subtotalSoles.totals.forEach((total, i) => {
				totals[init + i + 1] = total;
			});
			body.push(totals);
		}
		if (this.dataReport.subtotalDolares?.totals.length) {
			const totals: string[] = [];
			const init = this.dataReport.subtotalDolares.indexColumnStart;
			this.extractHeaders(this.dataReport.headers).forEach((it) => totals.push(''));
			totals[init] = 'SUB TOTAL DÓLARES';
			this.dataReport.subtotalDolares.totals.forEach((total, i) => {
				totals[init + i + 1] = total;
			});
			body.push(totals);
		}
		return body;
	}

	private hiddenColumn(indexColumn: number): boolean {
		if (!this.dataReport.configColumn) {
			return false;
		}
		const config = this.dataReport.configColumn.find((config) => config.indexColumn === indexColumn);

		if (config == undefined) {
			return false;
		}

		return config.hidden === undefined ? false : config.hidden;
	}
}
